import { Slot } from 'booking/lib/types';
import * as React from 'react';

export interface NearbySlots {
    isLoading: boolean;
    slots: ReadonlyArray<Slot>;
}

export interface NearbySlotsContextType {
    hasSlots: boolean;
    locations: Record<string, NearbySlots>;
}

const NearbySlotsContext = React.createContext<NearbySlotsContextType>({
    hasSlots: false,
    locations: {},
});

export default NearbySlotsContext;
